module.exports = __webpack_public_path__ + "static/media/bracelet.083424f9.jpg";